// import { Pages } from '../../../../models/blog.model'
// import { BlogService } from '../../../../services/blog.service'
import { Component, Input } from '@angular/core'
import { TranslateService } from '@ngx-translate/core'

@Component({
  selector: 'app-cta-desktop',
  templateUrl: './cta-desktop.component.html',
  styleUrls: ['./cta-desktop.component.scss', '../cta-component.scss'],
})
export class CtaDesktopComponent {
  @Input() lang = 'th'
  constructor(public translate: TranslateService) {}

  get headingText(): string {
    return this.lang === 'th'
      ? 'ช่วยให้ก้าวแรกของธุรกิจคุณไม่สะดุด ด้วย FlowAccount โปรแกรมบัญชี ออนไลน์ สำหรับนักธุรกิจยุคใหม่'
      : 'ช่วยให้ก้าวแรกของธุรกิจคุณไม่สะดุด ด้วย FlowAccount โปรแกรมบัญชี ออนไลน์ สำหรับนักธุรกิจยุคใหม่'
  }
  get headingText2(): string {
    return this.lang === 'th' ? 'ใช้งานง่าย ทำได้ด้วยตัวเอง' : 'ใช้งานง่าย ทำได้ด้วยตัวเอง'
  }

  get headingTextIpad1(): string {
    return this.lang === 'th' ? 'ช่วยให้ก้าวแรกของธุรกิจคุณไม่สะดุด' : 'ช่วยให้ก้าวแรกของธุรกิจคุณไม่สะดุด'
  }

  get headingTextIpad2(): string {
    return this.lang === 'th' ? 'ด้วย FlowAccount โปรแกรมบัญชี ออนไลน์' : 'ด้วย FlowAccount โปรแกรมบัญชี ออนไลน์'
  }

  get headingTextIpad3(): string {
    return this.lang === 'th'
      ? 'สำหรับนักธุรกิจยุคใหม่ ใช้งานง่าย ทำได้ด้วยตัวเอง'
      : 'สำหรับนักธุรกิจยุคใหม่ ใช้งานง่าย ทำได้ด้วยตัวเอง'
  }

  get regisText(): string {
    return this.lang === 'th' ? 'สมัครใช้งานฟรี' : 'Sign up'
  }
}
